"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageDialogsProvider = void 0;
const vue_1 = __importDefault(require("vue"));
const fragments_1 = require("../../fragments");
const provider_base_1 = require("../provider-base");
class HomePageDialogsProvider extends provider_base_1.BaseProvider {
    static async getHomePageFragment() {
        const fragment = await fragments_1.FragmentsLoaderProvider.fragmentsLoader.loadFragment(fragments_1.FragmentName.homePage);
        return fragment;
    }
    static async openUserProfilingDialog(userType, isCoAuthor) {
        const homePageFragment = await this.getHomePageFragment();
        const mountUtils = fragments_1.MountUtils.createInstance(new vue_1.default());
        this.mountedDialogs.openUserProfilingDialog = await mountUtils.mountDialog(homePageFragment, homePageFragment.openUserProfilingDialog, { userType, isCoAuthor });
    }
    static async closeUserProfilingDialog() {
        var _a;
        await ((_a = this.mountedDialogs.openUserProfilingDialog) === null || _a === void 0 ? void 0 : _a.close());
        delete this.mountedDialogs.openUserProfilingDialog;
    }
}
exports.HomePageDialogsProvider = HomePageDialogsProvider;
